<div class="mibarra px-1 px-lg-5 w-100 mx-0 my-4 my-lg-3 mt-lg-4">
  <div class="">
    <div class="mx-0 px-0 col-md-12 justify-content-start">
      <div class="d-flex justify-content-between align-items-center">
        <div class="step-text">
          <strong class="d-none d-sm-inline"
            >Paso {{ activeStep + 1 }} de 5:</strong
          >
          <span [ngClass]="{ 'font-weight-bold': isMobile() }">
            {{ getCurrentSteps()[activeStep] }}
          </span>
        </div>
        <div *ngIf="activeStep + 1 !== 5" class="next-stop-text">
          Siguiente: {{ getNextStepText() }}
        </div>
      </div>

      <div class="container-fluid p-2 align-items-center">
        <div class="d-flex justify-content-around">
          <span
            *ngFor="let step of [1, 2, 3, 4, 5]; let i = index"
            [ngClass]="{
              'bg-custom': i < activeStep,
              'bg-custom-actual': i === activeStep,
              'bg-custom-success': i > activeStep
            }"
            class="bg-success w-25 rounded mt-auto mb-auto me-1 ms-1 d-flex justify-content-center align-items-center"
            style="height: 0.3rem"
          >
            <img
              *ngIf="i === activeStep"
              src="./assets/img/Casa-blanca.png"
              alt="Cheque"
              class="casa-border"
            />
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

